<template>
  <div class="flex">
    <slot />
  </div>
</template>

<script lang="ts" setup>
</script>
